define('bindingHandlers/csvErrorDisplay',[
    'jquery',
    'lib/lodash4',
    'lib/knockout'
], function ($, _, ko) {
    'use strict';

    /**
     * Checks for error in the CSV list then formats entries with error
     * @param targetObsv Target Observable containing value to be written to the screen
     * @param element HTML element where to write list
     */
    var checkForError = function(targetObsv, element) {
        var listArray = ko.unwrap(targetObsv);

        if (targetObsv.errorDetails && targetObsv.errorDetails.length >0){
            var modifiedInput = '';
            _.each(listArray, function (entry,index) {
                var item = (entry.toString()).trim();
                if (index!==0){
                    modifiedInput+=", ";
                }
                if (targetObsv.errorDetails[index]) {
                    modifiedInput+= "<span class='invalid-list-item'>"+item+"</span>";
                }
                else {
                    modifiedInput+= "<span>"+item+"</span>";
                }
            });
            $(element).html(modifiedInput);
        }
    };

    /**
     * <p>CSV Error Display Binding</p>
     * <p>
     * This binding works together with the csvListValidation Rule to display errors reported by this rule
     * Binding example: data-bind = "csvErrorDisplay: site().informationNumbers"
     * </p>
     * @exports bindingHandlers/dropdown
     */
    ko.bindingHandlers.csvErrorDisplay = {
        update: function(element, valueAccessor){
            var prop = ko.unwrap(valueAccessor);
            var listValue = prop();
            checkForError(listValue, element);
        }
    };

});

